export const largeBoxes = [
    {
        title: "The cost of care: A student clings to hope in face of inadequate treatment",
        topics: ["Healthcare", "Student Fees"],
        author: "Vivian Landis",
        imageSrc: "./assets/unmc.jpg",
        articleLink: "https://www.dailynebraskan.com/the-cost-of-care-a-student-clings-to-hope-in-face-of-inad[…]eatment/article_41cea970-da83-11ee-a8c5-23a037488414.html"
    },
    {
        title: "How UNL helps student-athletes recover from in-season injuries",
        topics: ["Athletics", "Student Health", "Mental Health"],
        author: "Rachel Miller",
        imageSrc: "./assets/athleteRecovery.jpg",
        articleLink: "https://www.dailynebraskan.com/how-unl-helps-student-athletes-recover-from-in-season-injuries/article_dad2eb58-da84-11ee-a3fd-ebe302c3bed7.html"
    },
    {
        title: "OPINION: Freshman year takes a toll on student health",
        topics: ["Mental Health"],
        author: "Kennedy Lawrence",
        imageSrc: "./assets/freshmanHealth.jpg",
        articleLink: "https://www.dailynebraskan.com/opinion-freshman-year-takes-a-toll-on-student-health/article_97c965c2-da88-11ee-a406-7b22bc0f12b9.html"
    },
    {
        title: "It's time for UNL to make transgender healthcare more accessible to students",
        topics: ["Inclusivity", "Healthcare"],
        author: "Alex Gryczanowski and Evie Storjohann",
        imageSrc: "./assets/transgenderCare.jpg",
        articleLink: "https://www.dailynebraskan.com/it-s-time-for-unl-to-make-transgender-healthcare-more-acc[…]tudents/article_533eaea6-da80-11ee-ab86-1bc1559fc30c.html"
    },
];

export const smallBoxes = [
    {
        title: "International student from Brazil shares mental health journey at UNL",
        topics: ["Mental Health", "Campus Resources"],
        author: "Andres Lopez",
        imageSrc: "./assets/internationalStudent.jpg",
        articleLink: "https://www.dailynebraskan.com/international-student-from-brazil-shares-mental-health-jo[…]-at-unl/article_6aa48a9e-da84-11ee-947c-67cedf62f215.html"
    },
    {
        title: "UNL's Injury Prevention and Care program, a saving grace for club athletes, students",
        topics: ["Athletics", "Healthcare"],
        author: "Alex Kopf and Sean Rodgers",
        imageSrc: "./assets/injuryPrevention2.jpg",
        articleLink: "https://www.dailynebraskan.com/unl-s-injury-prevention-and-care-program-a-saving-grace-f[…]tudents/article_33e4c68c-da83-11ee-8ea1-973768123754.html"
    },
    {
        title: "How inclusive design is making spaces at UNL accessible to everyone",
        topics: ["Inclusivity"],
        author: "Justin Diep",
        imageSrc: "./assets/inclusiveDesign.jpg",
        articleLink: "https://www.dailynebraskan.com/how-inclusive-design-is-making-spaces-at-unl-accessible-to-everyone/article_45631816-da81-11ee-b7e2-6bdf594adfd0.html"
    },
    {
        title: "A portion of UNL student fees are paying for CAPS. Do they see its worth?",
        topics: ["Campus Resources", "Student Fees"],
        author: "Meghan O'Brien",
        imageSrc: "./assets/caps.jpg",
        articleLink: "https://www.dailynebraskan.com/a-portion-of-unl-student-fees-are-paying-for-caps-do-they[…]s-worth/article_98be095e-da8a-11ee-8bb6-7b4318dc7cde.html"
    },
    {
        title: "A guide to body neutrality: How UNL helps students' mental health",
        topics: ["Mental Health"],
        author: "Camille Andelt",
        imageSrc: "./assets/body-sized.png",
        articleLink: "https://www.dailynebraskan.com/a-guide-to-body-neutrality-how-unl-helps-students-mental-health/article_bd910bd6-da86-11ee-a032-ff382ad3efe9.html"
    },
    {
        title: "OPINION: Get your flu shot",
        topics: ["Healthcare"],
        author: "Elise St Clair",
        imageSrc: "./assets/flu-sized.png",
        articleLink: "https://www.dailynebraskan.com/opinion-get-your-flu-shot/article_b3b117f2-db47-11ee-ab65-97d5923ff7fb.html"
    },
    {
        title: "Ozempic introduces new questions about student weight loss",
        topics: ["Student Health"],
        author: "Josie Golka",
        imageSrc: "./assets/ozempic-sized.png",
        articleLink: "https://www.dailynebraskan.com/ozempic-introduces-new-questions-about-student-weight-loss/article_c8ad0f4e-da89-11ee-aa05-23414b4077bf.html"
    },
    {
        title: "OPINION: Use the campus rec center for your mental health",
        topics: ["Mental Health", "Campus Resources"],
        author: "Jalen-Thomas Kroger",
        imageSrc: "./assets/rec-sized.png",
        articleLink: "https://www.dailynebraskan.com/opinion-use-the-campus-rec-center-for-your-mental-health/article_dd5ff5b6-db45-11ee-9ebb-af2dd19b759b.html"
    },
];